import { AfterViewInit, Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appPopover]',
  standalone: true,
})
export class PopoverDirective implements OnInit, AfterViewInit {
  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.el.nativeElement.classList.add('app-popover');
  }

  ngAfterViewInit(): void {
    console.log(this.el.nativeElement.children[0].textContent);
    if (!this.el.nativeElement.children[0].textContent?.length) {
      this.el.nativeElement.classList.add('tw-hidden');
    }
  }

  @HostListener('click', ['$event']) onClick() {
    this.el.nativeElement.classList.add('active');
  }

  @HostListener('document:click', ['$event']) onLeave(event: Event) {
    const target = event.target as HTMLElement;
    const show = this.el.nativeElement.contains(target);
    if (!show) this.el.nativeElement.classList.remove('active');
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.el.nativeElement.classList.add('active');
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.el.nativeElement.classList.remove('active');
  }
}
